import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "h2 color-text-primary code-step__title" }
const _hoisted_2 = { class: "color-grey-blue caption-medium" }
const _hoisted_3 = {
  key: 0,
  class: "color-error"
}
const _hoisted_4 = {
  key: 1,
  class: "color-error"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "code-step__timer"
}

import { computed, onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import BaseInput from "@/components/base/BaseInput.vue";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CodeStep',
  props: {
    phone: {},
    errorCount: {}
  },
  emits: ["back", "submit", "resend"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const { t } = useI18n();

const codeLength = ref(4);
const code = ref("");
const timer = ref(60);

const canResend = computed(() => timer.value === 0);
const formattedTime = computed(() => {
  const minutes = Math.floor(timer.value / 60);
  const seconds = timer.value % 60;

  return `(${minutes}:${seconds.toString().padStart(2, "0")})`;
});

let timerInterval: number;

const handleSubmit = () => {
  if (code.value.length !== codeLength.value) return;

  emit("submit", code.value);
};

const handleResend = () => {
  emit("resend");
  timer.value = 60;
  startTimer();
};

const startTimer = () => {
  clearInterval(timerInterval);
  timerInterval = setInterval(() => {
    timer.value--;

    if (timer.value <= 0) {
      clearInterval(timerInterval);
    }
  }, 1000);
};

const handleClick = () => {
  if (code.value.length === codeLength.value) {
    code.value = "";
  }
};

onMounted(() => {
  startTimer();
});

watch(
  () => code.value,
  () => {
    if (code.value.length === codeLength.value) {
      handleSubmit();
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["code-step", { 'error-state': props.errorCount >= codeLength.value }])
  }, [
    _createElementVNode("div", null, [
      _createVNode(BaseFigureForIcon, {
        size: "medium",
        color: "grey-secondary",
        icon: "arrow",
        position: "left",
        "is-button": "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back')))
      }),
      _createElementVNode("h2", _hoisted_1, _toDisplayString(_unref(t)("auth.code.title")), 1),
      _createElementVNode("p", _hoisted_2, [
        _createTextVNode(_toDisplayString(_unref(t)("auth.code.sentToNumber")), 1),
        _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
        _createTextVNode(_toDisplayString(props.phone), 1)
      ]),
      _createVNode(BaseInput, {
        modelValue: code.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((code).value = $event)),
        type: "code",
        "code-length": codeLength.value,
        class: _normalizeClass([{ 'error-state': props.errorCount > 0 }, "code-step__input"]),
        onClick: handleClick
      }, null, 8, ["modelValue", "code-length", "class"]),
      (props.errorCount > 0 && props.errorCount < 5)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(t)("auth.code.invalid")), 1))
        : _createCommentVNode("", true),
      (props.errorCount >= 5)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(t)("auth.code.tooManyAttempts", {
            count: props.errorCount,
            time: formattedTime.value,
          })), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("button", {
      class: _normalizeClass(["caption-small--bold code-step__resend color-text-primary pointer", {
        'resend-button--disabled': !canResend.value,
      }]),
      disabled: !canResend.value,
      onClick: handleResend
    }, [
      _createTextVNode(_toDisplayString(_unref(t)("auth.code.resend")) + " ", 1),
      (!canResend.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(formattedTime.value), 1))
        : _createCommentVNode("", true)
    ], 10, _hoisted_5)
  ], 2))
}
}

})